module.exports = __webpack_public_path__ + "h5/img/strokes-5.67a6f4b0.png";